import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { AngularFireFunctions } from '@angular/fire/functions';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@app/environments/environment';

declare var Stripe: any;

const stripe = Stripe(environment.stripe.key);

@Component({
  selector: 'app-stripe-external',
  templateUrl: './stripe-external.component.html',
  styleUrls: ['./stripe-external.component.css']
})
export class StripeExternalComponent implements OnInit, AfterViewInit {
  private notifier: any;
  accountDetails: FormGroup;
  processLoading = false;
  constructor(
    private router: Router,
    private fun: AngularFireFunctions,
    private notifierService: NotifierService,
    private changeRef: ChangeDetectorRef,
    public activeModal: NgbActiveModal
  ) {
    this.notifier = notifierService;
    this.accountDetails = new FormGroup({
      name: new FormControl('', Validators.compose([Validators.required])),
      accountNo: new FormControl('000123456', Validators.compose([Validators.required])),
      branchcode: new FormControl('', Validators.compose(
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(3),
          Validators.pattern('[0-9]*')
        ])),
      bankcode: new FormControl('', Validators.compose(
        [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(4),
          Validators.pattern('[0-9]*')
        ]))
    });
  }

  ngOnInit() {
  }
  ngAfterViewInit(): void {
    this.changeRef.detectChanges();
  }

  async addExternalBankAccount(formData) {
    console.log('Start Adding of External Bank Account in Stripe');
    this.processLoading = true;
    const bankInfo = await stripe.createToken('bank_account', {
      country: 'SG',
      currency: 'SGD',
      routing_number: formData.value.bankcode + '-' + formData.value.branchcode, // 1100-000
      account_number: formData.value.accountNo,
      account_holder_name: formData.value.name,
      account_holder_type: 'individual',
    });

    if (bankInfo.error) {
      // Inform the customer that there was an error.
      this.notifier.notify(
        'error',
        'Adding of Bank Account Error: ' + bankInfo.error.message
      );
      console.log('error bank');
      this.processLoading = false;
    } else {
      try {
        const data = {
          bank_token: bankInfo.token.id
        };

        const resultCode = await this.fun.httpsCallable('addExternalBank')(data).toPromise();
        this.notifier.notify(
          'success',
          resultCode
        );
        console.log('resultCode', resultCode);
        this.processLoading = false;
        this.activeModal.close();
        this.router.navigate(['profile']);
      } catch (error) {
        this.notifier.notify(
          'error',
          'Failed to Bank Account Details' + error
        );
        this.processLoading = false;
      }
    }
  }
}
